import * as React from 'react'
import { ScheduleServiceCallToActionSection } from '../components/AboutPage/ScheduleServiceCallToActionSection'
import Head from 'next/head'
import { ContactUsFormSection } from '../components/Contact/ContactUsFormSection'
import Layout from '../components/Layout'
import { AboutPageTitleSection } from '../components/AboutPageTitleSection'

const ContactPage = () => (
  <Layout title={`Contact Us - NuBrakes Mobile Brake Repair`}>
    <Head>
      <meta name="description" content="Contact the NuBrakes mobile brake repair team." />
    </Head>
    <AboutPageTitleSection title={'Contact Us'} />
    <ContactUsFormSection />
    <ScheduleServiceCallToActionSection title={`Schedule your mobile brake repair in minutes.`} />
  </Layout>
)

export default ContactPage
